<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-card-text>Are you sure you want to remove this Q&A from the accommodation {{hsva.huis_code}} ?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small @click="rmHsva">Yes</v-btn>
                <v-btn color="success"  small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        data() { 
            return {
                dialog: false,
                hsva_encrid: null,
                hsva: {}
            }
        },
        methods: {
            open(hsva_encrid) {
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hsva/getHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsva"
                    },
                    getHsva: {
                        hsva_encrid: hsva_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsva = res.data.getHsva;
                    }
                });
            },
            rmHsva() { 
                this.$axios.post("ares/json/ares/huis/hsva/rmHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHsva"
                    },
                    rmHsva: {
                        hsva_encrid: this.hsva.hsva_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmHsva.text,
                            color: res.data.rmHsva.color
                        });
                        this.$emit("reload", "reload");
                        this.dialog = false;
                    }
                })
            },
        }
    }
</script>

